import { Component, OnInit } from '@angular/core';
import { SupaService } from '../../services/supa.service';
import { HelperService } from '../../services/helper.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {

  email = ''
  password = ''

  constructor(private supa: SupaService, private helper: HelperService) { }

  enterSubmit(event: any) {
    this.signIn();
  }

  async signIn() {
    const { error } = await this.supa.supabase.auth.signInWithPassword({email: this.email, password: this.password});
    if(error) {
      this.helper.notify('Could not sign in, ' + error.message, 'danger')
    }
    console.log(error);
  }
}
